import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import {FusePageSimple} from '@fuse';
import { Divider, Chip, Paper, Grid, Button, SwipeableDrawer, Typography, Tabs, Tab, Card, CardContent, CardActionArea, CardActions } from '@material-ui/core';
// import Pagination from "material-ui-flat-pagination";

import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as Actions from 'store/actions';

import HomeIcon from '@material-ui/icons/Home';
import MenuIcon from '@material-ui/icons/Assignment';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';

const styles = theme => ({
    layoutRoot: {}
});

class PusatUnduhan extends Component {

    constructor(props) {
        super(props);
        this.state = {
            error: null,
            isLoaded: false,
            namaPengguna: 'Khalid',
            bottom: false,
            ListMenu: null,
            email: null,
            routeParams: {
                peran_id: JSON.parse(localStorage.getItem('user')).peran_id,
                token: localStorage.getItem('jwt_token')
            },
            tabsValue: 0
        };
    }

    goTolink = (url) => {
        this.props.history.push(url);
        // alert('oke ganti');
    };

    handleChangeTab = (event, value) => {
        this.setState({
            ...this.state,
            tabsValue: value
        })
    }

    componentDidMount = () => {
        this.props.setJudul("Pusat Unduhan");
    }

    bukaMenuUtama = () => {
        this.setState({ 
            ...this.state, 
            bottom: true
        });
    }

    toggleDrawer = (side, open, option) => () => {
        this.setState({ ...this.state, [side]: open });
    }

    klikUnduh = (tipe) => () => {
        // alert(tipe);
        let url = '';
        switch (tipe) {
            case 'SD_2018':
                url = 'http://'+window.location.hostname+':'+window.location.port+'/assets/unduhan/2018/01 PERANGKAT INSTRUMEN PEMETAAN TAHUN 2018_SD.pdf';
                break;
            case 'SMP_2018':
                url = 'http://'+window.location.hostname+':'+window.location.port+'/assets/unduhan/2018/02 PERANGKAT INSTRUMEN PEMETAAN TAHUN 2018_SMP.pdf';
                break;
            case 'SMA_2018':
                url = 'http://'+window.location.hostname+':'+window.location.port+'/assets/unduhan/2018/03 PERANGKAT INSTRUMEN PEMETAAN TAHUN 2018_SMA.pdf';
                break;
            case 'SMK_2018':
                url = 'http://'+window.location.hostname+':'+window.location.port+'/assets/unduhan/2018/04 PERANGKAT INSTRUMEN PEMETAAN TAHUN 2018_SMK.pdf';
                break;
            case 'SD_2017':
                url = 'http://'+window.location.hostname+':'+window.location.port+'/assets/unduhan/2017/01 PERANGKAT INSTRUMEN PEMETAAN TAHUN 2017_SD v24052017.pdf';
                break;
            case 'SMP_2017':
                url = 'http://'+window.location.hostname+':'+window.location.port+'/assets/unduhan/2017/02 PERANGKAT INSTRUMEN PEMETAAN TAHUN 2017_SMP v24052017.pdf';
                break;
            case 'SMA_2017':
                url = 'http://'+window.location.hostname+':'+window.location.port+'/assets/unduhan/2017/03 PERANGKAT INSTRUMEN PEMETAAN TAHUN 2017_SMA v24052017.pdf';
                break;
            case 'SMK_2017':
                url = 'http://'+window.location.hostname+':'+window.location.port+'/assets/unduhan/2017/04 PERANGKAT INSTRUMEN PEMETAAN TAHUN 2017_SMK v24052017.pdf';
                break;

            case 'SD_2019':
                url = 'http://'+window.location.hostname+':'+window.location.port+'/assets/unduhan/2019/01_PERANGKAT_INSTRUMEN_2019_JENJANG_SD.pdf';
                break;
            case 'SMP_2019':
                url = 'http://'+window.location.hostname+':'+window.location.port+'/assets/unduhan/2019/02_PERANGKAT_INSTRUMEN_2019_JENJANG_SMP.pdf';
                break;
            case 'SMA_2019':
                url = 'http://'+window.location.hostname+':'+window.location.port+'/assets/unduhan/2019/03_PERANGKAT_INSTRUMEN_2019_JENJANG_SMA.pdf';
                break;
            case 'SMK_2019':
                url = 'http://'+window.location.hostname+':'+window.location.port+'/assets/unduhan/2019/04_PERANGKAT_INSTRUMEN_2019_JENJANG_SMK.pdf';
                break;

            default:
                break;
        }

        window.open(url);
    }

    render()
    {
        const {classes} = this.props;
        const {bottom, ListMenu} = this.state;

        return (
            <FusePageSimple
                classes={{
                    root: classes.layoutRoot
                }}
                
                content={
                    <div style={{width: '100%'}} className="konten-utama">
                        
                        {/* <div className="p-16" style={{border: '0px solid #ccc', width: '100%', background: 'url(http://'+window.location.hostname+':'+window.location.port+'/assets/images/backgrounds/kemajuan.png)', marginTop: '-1px', backgroundPosition: 'center', backgroundSize: 'cover', minHeight: 89}}>
                            <Grid container spacing={16}>
                                <Grid item xs={12} sm={12} style={{paddingLeft: 10}}>
                                    <h1 style={{fontSize: 25, fontFamily: 'Helvetica', color: 'white'}}>Pusat Unduhan</h1>
                                </Grid>
                            </Grid>
                        </div> */}

                        <div style={{minHeight: 10, width: '100%', background: '#4EBBE8', overflow: 'auto', maxHeight: '42px', display: 'inline-flex'}}>
                            <Chip
                                icon={<HomeIcon/>}
                                label=""
                                className={this.props.classes.chip}
                                color="primary"
                                style={{justifyContent: 'start', marginLeft: 0, padding: 5, borderRadius: 0, borderRight: '1px solid #ccc', paddingLeft: '0px', paddingRight: '0px'}}
                                onClick={()=>{this.goTolink('/Beranda')}}
                                />
                            <Chip
                                label="> Pusat Unduhan"
                                className={this.props.classes.chip}
                                color="secondary"
                                // onClick={()=>{this.goTolink('/ManajemenPengguna')}}
                                style={{justifyContent: 'start', marginRight: 0, padding: 5, borderRadius: 0, paddingLeft: 0, paddingRight: 0, fontSize: 12}}
                            />
                        </div>
                        
                        {/* <Paper className="p-8 paperPengembangan">
                            <Typography variant="display2" style={{color:'white'}}>
                                Menu ini sedang dalam pengembangan
                            </Typography>
                            <Typography variant="headline" style={{color:'white'}}>
                                Tunggu Kami sedikit lagi ya, di versi selanjutnya :)
                            </Typography>
                        </Paper> */}
                        <Tabs
                            value={this.state.tabsValue}
                            indicatorColor="primary"
                            textColor="primary"
                            onChange={this.handleChangeTab}
                        >
                            <Tab icon={<MenuIcon />} label="Perangkat Instrumen" classes={{ selected: classes.tabSelected }}/>
                            {/* <Tab icon={<MenuIcon />} label="Panduan" classes={{ selected: classes.tabSelected }}/> */}
                        </Tabs>
                        {this.state.tabsValue === 0 && 
                        <Paper className="p-8">
                            <Typography variant="display1">
                                Instrumen Tahun 2020
                            </Typography>
                            <Divider/>
                            <br/>
                            <br/>
                            {/* <Grid container spacing={16}>
                                <Grid item xs={6} sm={3} lg={2}>
                                    <Card className={classes.card}>
                                        <CardActionArea onClick={this.klikUnduh('SD_2019')}>
                                            <div
                                                style={{
                                                    background: 'url(http://'+window.location.hostname+':'+window.location.port+'/assets/images/etc/SD_2019.png)',
                                                    height: 200,
                                                    backgroundSize: '100%',
                                                    backgroundRepeat: 'no-repeat'
                                                }}
                                            >
                                                &nbsp;
                                            </div>
                                            <CardContent style={{height:90}}>
                                                <Typography gutterBottom variant="caption">
                                                01 PERANGKAT INSTRUMEN PEMETAAN TAHUN 2019 SD
                                                </Typography>
                                            </CardContent>
                                        </CardActionArea>
                                        <CardActions>
                                            <Button size="small" color="primary" onClick={this.klikUnduh('SD_2019')}>
                                                <CloudDownloadIcon/> &nbsp; Unduh
                                            </Button>
                                        </CardActions>
                                    </Card>
                                </Grid>
                                <Grid item xs={6} sm={3} lg={2}>
                                    <Card className={classes.card}>
                                        <CardActionArea onClick={this.klikUnduh('SMP_2019')}>
                                            <div
                                                style={{
                                                    background: 'url(http://'+window.location.hostname+':'+window.location.port+'/assets/images/etc/SMP_2019.png)',
                                                    height: 200,
                                                    backgroundSize: '100%',
                                                    backgroundRepeat: 'no-repeat'
                                                }}
                                            >
                                                &nbsp;
                                            </div>
                                            <CardContent style={{height:90}}>
                                                <Typography gutterBottom variant="caption">
                                                02 PERANGKAT INSTRUMEN PEMETAAN TAHUN 2019 SMP
                                                </Typography>
                                            </CardContent>
                                        </CardActionArea>
                                        <CardActions>
                                            <Button size="small" color="primary" onClick={this.klikUnduh('SMP_2019')}>
                                                <CloudDownloadIcon/> &nbsp; Unduh
                                            </Button>
                                        </CardActions>
                                    </Card>
                                </Grid>
                                <Grid item xs={6} sm={3} lg={2}>
                                    <Card className={classes.card}>
                                        <CardActionArea onClick={this.klikUnduh('SMA_2019')}>
                                            <div
                                                style={{
                                                    background: 'url(http://'+window.location.hostname+':'+window.location.port+'/assets/images/etc/SMA_2019.png)',
                                                    height: 200,
                                                    backgroundSize: '100%',
                                                    backgroundRepeat: 'no-repeat'
                                                }}
                                            >
                                                &nbsp;
                                            </div>
                                            <CardContent style={{height:90}}>
                                                <Typography gutterBottom variant="caption">
                                                03 PERANGKAT INSTRUMEN PEMETAAN TAHUN 2019 SMA
                                                </Typography>
                                            </CardContent>
                                        </CardActionArea>
                                        <CardActions>
                                            <Button size="small" color="primary" onClick={this.klikUnduh('SMA_2019')}>
                                                <CloudDownloadIcon/> &nbsp; Unduh
                                            </Button>
                                        </CardActions>
                                    </Card>
                                </Grid>
                                <Grid item xs={6} sm={3} lg={2}>
                                    <Card className={classes.card}>
                                        <CardActionArea onClick={this.klikUnduh('SMK_2019')}>
                                            <div
                                                style={{
                                                    background: 'url(http://'+window.location.hostname+':'+window.location.port+'/assets/images/etc/SMK_2019.png)',
                                                    height: 200,
                                                    backgroundSize: '100%',
                                                    backgroundRepeat: 'no-repeat'
                                                }}
                                            >
                                                &nbsp;
                                            </div>
                                            <CardContent style={{height:90}}>
                                                <Typography gutterBottom variant="caption">
                                                04 PERANGKAT INSTRUMEN PEMETAAN TAHUN 2019 SMK
                                                </Typography>
                                            </CardContent>
                                        </CardActionArea>
                                        <CardActions>
                                            <Button size="small" color="primary" onClick={this.klikUnduh('SMK_2019')}>
                                                <CloudDownloadIcon/> &nbsp; Unduh
                                            </Button>
                                        </CardActions>
                                    </Card>
                                </Grid>
                            </Grid> */}
                            <br/>
                            <Divider/>
                            <br/>


                            {/* <Typography variant="display1">
                                Instrumen Tahun 2018
                            </Typography>
                            <Divider/>
                            <br/>
                            <br/> */}
                            {/* <Grid container spacing={16}>
                                <Grid item xs={6} sm={3} lg={2}>
                                    <Card className={classes.card}>
                                        <CardActionArea onClick={this.klikUnduh('SD_2018')}>
                                            <div
                                                style={{
                                                    background: 'url(http://'+window.location.hostname+':'+window.location.port+'/assets/images/etc/SD.png)',
                                                    height: 200,
                                                    backgroundSize: '100%',
                                                    backgroundRepeat: 'no-repeat'
                                                }}
                                            >
                                                &nbsp;
                                            </div>
                                            <CardContent style={{height:90}}>
                                                <Typography gutterBottom variant="caption">
                                                01 PERANGKAT INSTRUMEN PEMETAAN TAHUN 2018 SD
                                                </Typography>
                                            </CardContent>
                                        </CardActionArea>
                                        <CardActions>
                                            <Button size="small" color="primary" onClick={this.klikUnduh('SD_2018')}>
                                                <CloudDownloadIcon/> &nbsp; Unduh
                                            </Button>
                                        </CardActions>
                                    </Card>
                                </Grid>
                                <Grid item xs={6} sm={3} lg={2}>
                                    <Card className={classes.card}>
                                        <CardActionArea onClick={this.klikUnduh('SMP_2018')}>
                                            <div
                                                style={{
                                                    background: 'url(http://'+window.location.hostname+':'+window.location.port+'/assets/images/etc/SMP.png)',
                                                    height: 200,
                                                    backgroundSize: '100%',
                                                    backgroundRepeat: 'no-repeat'
                                                }}
                                            >
                                                &nbsp;
                                            </div>
                                            <CardContent style={{height:90}}>
                                                <Typography gutterBottom variant="caption">
                                                02 PERANGKAT INSTRUMEN PEMETAAN TAHUN 2018 SMP
                                                </Typography>
                                            </CardContent>
                                        </CardActionArea>
                                        <CardActions>
                                            <Button size="small" color="primary" onClick={this.klikUnduh('SMP_2018')}>
                                                <CloudDownloadIcon/> &nbsp; Unduh
                                            </Button>
                                        </CardActions>
                                    </Card>
                                </Grid>
                                <Grid item xs={6} sm={3} lg={2}>
                                    <Card className={classes.card}>
                                        <CardActionArea onClick={this.klikUnduh('SMA_2018')}>
                                            <div
                                                style={{
                                                    background: 'url(http://'+window.location.hostname+':'+window.location.port+'/assets/images/etc/SMA.png)',
                                                    height: 200,
                                                    backgroundSize: '100%',
                                                    backgroundRepeat: 'no-repeat'
                                                }}
                                            >
                                                &nbsp;
                                            </div>
                                            <CardContent style={{height:90}}>
                                                <Typography gutterBottom variant="caption">
                                                03 PERANGKAT INSTRUMEN PEMETAAN TAHUN 2018 SMA
                                                </Typography>
                                            </CardContent>
                                        </CardActionArea>
                                        <CardActions>
                                            <Button size="small" color="primary" onClick={this.klikUnduh('SMA_2018')}>
                                                <CloudDownloadIcon/> &nbsp; Unduh
                                            </Button>
                                        </CardActions>
                                    </Card>
                                </Grid>
                                <Grid item xs={6} sm={3} lg={2}>
                                    <Card className={classes.card}>
                                        <CardActionArea onClick={this.klikUnduh('SMK_2018')}>
                                            <div
                                                style={{
                                                    background: 'url(http://'+window.location.hostname+':'+window.location.port+'/assets/images/etc/SMK.png)',
                                                    height: 200,
                                                    backgroundSize: '100%',
                                                    backgroundRepeat: 'no-repeat'
                                                }}
                                            >
                                                &nbsp;
                                            </div>
                                            <CardContent style={{height:90}}>
                                                <Typography gutterBottom variant="caption">
                                                04 PERANGKAT INSTRUMEN PEMETAAN TAHUN 2018 SMK
                                                </Typography>
                                            </CardContent>
                                        </CardActionArea>
                                        <CardActions>
                                            <Button size="small" color="primary" onClick={this.klikUnduh('SMK_2018')}>
                                                <CloudDownloadIcon/> &nbsp; Unduh
                                            </Button>
                                        </CardActions>
                                    </Card>
                                </Grid>
                            </Grid> */}
                            {/* <br/>
                            <Typography variant="display1">
                                Instrumen Tahun 2017
                            </Typography>
                            <Divider/>
                            <br/>
                            <br/> */}
                            {/* <Grid container spacing={16}>
                                <Grid item xs={6} sm={3} lg={2}>
                                    <Card className={classes.card}>
                                        <CardActionArea onClick={this.klikUnduh('SD_2017')}>
                                            <div
                                                style={{
                                                    background: 'url(http://'+window.location.hostname+':'+window.location.port+'/assets/images/etc/SD_2017.png)',
                                                    height: 200,
                                                    backgroundSize: '100%',
                                                    backgroundRepeat: 'no-repeat'
                                                }}
                                            >
                                                &nbsp;
                                            </div>
                                            <CardContent style={{height:90}}>
                                                <Typography gutterBottom variant="caption">
                                                01 PERANGKAT INSTRUMEN PEMETAAN TAHUN 2017 SD
                                                </Typography>
                                            </CardContent>
                                        </CardActionArea>
                                        <CardActions>
                                            <Button size="small" color="primary" onClick={this.klikUnduh('SD_2017')}>
                                                <CloudDownloadIcon/> &nbsp; Unduh
                                            </Button>
                                        </CardActions>
                                    </Card>
                                </Grid>
                                <Grid item xs={6} sm={3} lg={2}>
                                    <Card className={classes.card}>
                                        <CardActionArea onClick={this.klikUnduh('SMP_2017')}>
                                            <div
                                                style={{
                                                    background: 'url(http://'+window.location.hostname+':'+window.location.port+'/assets/images/etc/SMP_2017.png)',
                                                    height: 200,
                                                    backgroundSize: '100%',
                                                    backgroundRepeat: 'no-repeat'
                                                }}
                                            >
                                                &nbsp;
                                            </div>
                                            <CardContent style={{height:90}}>
                                                <Typography gutterBottom variant="caption">
                                                02 PERANGKAT INSTRUMEN PEMETAAN TAHUN 2017 SMP
                                                </Typography>
                                                
                                            </CardContent>
                                        </CardActionArea>
                                        <CardActions>
                                            <Button size="small" color="primary" onClick={this.klikUnduh('SMP_2017')}>
                                                <CloudDownloadIcon/> &nbsp; Unduh
                                            </Button>
                                        </CardActions>
                                    </Card>
                                </Grid>
                                <Grid item xs={6} sm={3} lg={2}>
                                    <Card className={classes.card}>
                                        <CardActionArea onClick={this.klikUnduh('SMA_2017')}>
                                            <div
                                                style={{
                                                    background: 'url(http://'+window.location.hostname+':'+window.location.port+'/assets/images/etc/SMA_2017.png)',
                                                    height: 200,
                                                    backgroundSize: '100%',
                                                    backgroundRepeat: 'no-repeat'
                                                }}
                                            >
                                                &nbsp;
                                            </div>
                                            <CardContent style={{height:90}}>
                                                <Typography gutterBottom variant="caption">
                                                03 PERANGKAT INSTRUMEN PEMETAAN TAHUN 2017 SMA
                                                </Typography>
                                                
                                            </CardContent>
                                        </CardActionArea>
                                        <CardActions>
                                            <Button size="small" color="primary" onClick={this.klikUnduh('SMA_2017')}>
                                                <CloudDownloadIcon/> &nbsp; Unduh
                                            </Button>
                                        </CardActions>
                                    </Card>
                                </Grid>
                                <Grid item xs={6} sm={3} lg={2}>
                                    <Card className={classes.card}>
                                        <CardActionArea onClick={this.klikUnduh('SMK_2017')}>
                                            <div
                                                style={{
                                                    background: 'url(http://'+window.location.hostname+':'+window.location.port+'/assets/images/etc/SMK_2017.png)',
                                                    height: 200,
                                                    backgroundSize: '100%',
                                                    backgroundRepeat: 'no-repeat'
                                                }}
                                            >
                                                &nbsp;
                                            </div>
                                            <CardContent style={{height:90}}>
                                                <Typography gutterBottom variant="caption">
                                                04 PERANGKAT INSTRUMEN PEMETAAN TAHUN 2017 SMK
                                                </Typography>
                                                
                                            </CardContent>
                                        </CardActionArea>
                                        <CardActions>
                                            <Button size="small" color="primary" onClick={this.klikUnduh('SMK_2017')}>
                                                <CloudDownloadIcon/> &nbsp; Unduh
                                            </Button>
                                        </CardActions>
                                    </Card>
                                </Grid>
                            </Grid> */}
                        </Paper>
                        }
                        {this.state.tabsValue === 1 && 
                        <Paper className="p-8">
                            <Typography variant="display1">
                                Panduan Aplikasi PMP
                            </Typography>
                            <Divider/>
                            <br/>
                            <br/>
                            <Grid container spacing={16}>
                                <Grid item xs={6} sm={3} lg={2}>
                                    <Card className={classes.card}>
                                        <CardActionArea onClick={this.klikUnduh('SD_2017')}>
                                            <div
                                                style={{
                                                    background: 'url(http://'+window.location.hostname+':'+window.location.port+'/assets/images/etc/SD_2017.png)',
                                                    height: 200,
                                                    backgroundSize: '100%',
                                                    backgroundRepeat: 'no-repeat'
                                                }}
                                            >
                                                &nbsp;
                                            </div>
                                            <CardContent style={{height:90}}>
                                                <Typography gutterBottom variant="caption">
                                                01 PERANGKAT INSTRUMEN PEMETAAN TAHUN 2017 SD
                                                </Typography>
                                                {/* <Typography component="p">
                                                    Lizards are a widespread group of squamate reptiles, with over 6,000 species, ranging
                                                    across all continents except Antarctica
                                                </Typography> */}
                                            </CardContent>
                                        </CardActionArea>
                                        <CardActions>
                                            <Button size="small" color="primary" onClick={this.klikUnduh('SD_2017')}>
                                                <CloudDownloadIcon/> &nbsp; Unduh
                                            </Button>
                                        </CardActions>
                                    </Card>
                                </Grid>
                            </Grid>
                        </Paper>
                        }
                        
                        <SwipeableDrawer
                            anchor="bottom"
                            open={bottom}
                            onClose={this.toggleDrawer('bottom', false, null)}
                            onOpen={this.toggleDrawer('bottom', true, null)}
                        >
                            <div style={{padding: 0, minHeight: 100, maxHeight: 400, overflow: 'auto'}}>
                                {ListMenu}
                            </div>
                        </SwipeableDrawer>
                    </div>
                }
            />
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getPengguna: Actions.getPengguna,
        tukarPengguna: Actions.tukarPengguna,
        getPeran: Actions.getPeran,
        setJudul: Actions.setJudul
    }, dispatch);
}

function mapStateToProps({ Pengguna }) {

    return {
        pengguna: Pengguna.pengguna,
        hasil_tukar_pengguna: Pengguna.hasil_tukar_pengguna,
        peran: Pengguna.peran
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(PusatUnduhan)));



// WEBPACK FOOTER //
// ./src/main/content/example/PusatUnduhan.js